import React, { useState } from 'react';
import Modal from './Modal';
import DateTimePickerModal from './DateTimePickerModal';
import '../css/EditScheduledPublishingModal.css'; // Ensure you create this or use inline styles
import { useTranslation } from '../hooks/useTranslation';
import { formatFullDateTime } from '../utils/dateUtils';

const EditScheduledPublishingModal = ({
  isOpen,
  onClose,
  currentDate,
  onCancelPublishing,
  onReschedulePublishing,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [newDate, setNewDate] = useState(currentDate);
  const t = useTranslation();
  // Update newDate when currentDate prop changes or modal opens
  React.useEffect(() => {
    if (currentDate) {
      setNewDate(currentDate);
    }
  }, [currentDate, isOpen]);

  const handleRescheduleClick = () => {
    if (newDate) {
      onReschedulePublishing(
        new Date(newDate).toISOString(),
        Intl.DateTimeFormat().resolvedOptions().timeZone
      );
    }
  };

  if (!isOpen) return null;

  return (
    <Modal
      modalStyle={{
        width: '550px',
        padding: '20px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.35)',
        border: '1px solid #1A192B',
      }}
    >
      <div className="esp-modal-header">
        <h3 className="content_change_popup  fs-12 fw-500 global-color mt-0 mb-5 d-block">
          {t('edit_scheduled_publishing')}
        </h3>
      </div>
      <div className="esp-modal-body" style={{ padding: '0px 0' }}>
        <div className="esp-field">
          <label className="content_change_popup  fs-12 fw-500 global-color mt-0 mb-5 d-block">
            {t('publishing_date')}
          </label>
          <div className="p-10 b-1">
            <span>{formatFullDateTime(newDate) || 'Not scheduled'}</span>
            <button
              className="btn-small"
              style={{
                marginLeft: '10px',
                padding: '3px 8px',
                background: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onClick={() => setIsCalendarOpen(true)}
            >
              {t('edit')}
            </button>
          </div>
        </div>

        <DateTimePickerModal
          isOpen={isCalendarOpen}
          onClose={() => setIsCalendarOpen(false)}
          minDate={new Date()}
          onSave={(value) => {
            setNewDate(value);
            setIsCalendarOpen(false);
          }}
        />
        <label className="content_change_popup  fs-12 fw-500 global-color mt-10 mb-5 d-block">
          {t('stop_publishing')}
        </label>
        <div className="esp-field p-10 b-1">
          <p className="fs-12 mt-0">
            {t(
              'be_careful_cancelling_the_publishing_will_prevent_the_model_from_being_published_and_you_will_have_to_restart_the_approval_of_the_model'
            )}
          </p>
          <button onClick={onCancelPublishing} className="btn-small-red ">
            {t('cancel_publishing')}
          </button>
        </div>
      </div>
      <div
        className="esp-modal-footer"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '10px',
          borderTop: '1px solid #ddd',
          paddingTop: '15px',
        }}
      >
        <button onClick={onClose} className="button_secondary">
          {t('Exit')}
        </button>
        <button onClick={handleRescheduleClick} className="button_primary">
          {t('rescheduled')}
        </button>
      </div>
    </Modal>
  );
};

export default EditScheduledPublishingModal;
